import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/logo.js';
import { RichContent } from '../components/RichText';

const fmtSize = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round((b || 0) / 1024))} KB`);

// Public page a staff member opens from their emailed link — no login; the long private link is the key
export default function AnnouncementView() {
  const { token } = useParams();
  const [data, setData]   = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`/api/announcements/view/${encodeURIComponent(token)}`)
      .then(({ data }) => setData(data))
      .catch(err => setError(err.response?.data?.message || 'Something went wrong. Please try again.'));
  }, [token]);

  const shell = (children) => (
    <div style={{ minHeight:'100vh', background:'var(--bg)', fontFamily:'Inter,sans-serif' }}>
      <div style={{ background:'var(--surface)', borderBottom:'1px solid var(--border)', padding:'10px 16px', display:'flex', alignItems:'center', gap:'10px' }}>
        <div style={{ width:'34px', height:'34px', background:'#000', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center' }}>
          <img src={logo} alt="" style={{ width:'30px', height:'30px', objectFit:'contain' }}/>
        </div>
        <div style={{ fontSize:'15px', fontWeight:'600', color:'var(--text)' }}>Car Saloon</div>
      </div>
      <div style={{ maxWidth:'680px', margin:'0 auto', padding:'24px 16px 60px' }}>{children}</div>
    </div>
  );

  if (error) return shell(
    <div style={{ textAlign:'center', padding:'40px 10px' }}>
      <div style={{ width:'56px', height:'56px', borderRadius:'50%', background:'var(--red-bg)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
        <i className="ti ti-link-off" style={{ fontSize:'26px', color:'var(--red)' }} aria-hidden="true"/>
      </div>
      <p style={{ color:'var(--text)', fontSize:'14px', lineHeight:1.6 }}>{error}</p>
    </div>);

  if (!data) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <i className="ti ti-loader" style={{ fontSize:'24px', color:'var(--blue)' }} aria-hidden="true"/>
    </div>);

  const a = data.announcement;
  return shell(
    <>
      <p style={{ fontSize:'13px', color:'var(--muted)', margin:'0 0 6px' }}>Hi {data.recipientName},</p>
      <h1 style={{ fontSize:'22px', fontWeight:'600', color:'var(--text)', margin:'0 0 6px', lineHeight:1.3 }}>{a.title}</h1>
      <p style={{ fontSize:'12px', color:'var(--hint)', margin:'0 0 18px' }}>
        From {a.senderName} · {new Date(a.sentAt).toLocaleDateString('en-AU', { day:'numeric', month:'long', year:'numeric' })}
      </p>

      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'18px 18px 8px', marginBottom:'18px' }}>
        <RichContent html={a.messageHtml || ''}/>
      </div>

      {a.videos.map(v => (
        <div key={v.videoId} style={{ marginBottom:'18px' }}>
          {v.title && <div style={{ fontSize:'13px', fontWeight:'500', color:'var(--text)', marginBottom:'6px' }}>{v.title}</div>}
          <div style={{ position:'relative', paddingTop:'56.25%', background:'#000', borderRadius:'var(--radius-lg)', overflow:'hidden' }}>
            <iframe src={`https://www.youtube-nocookie.com/embed/${v.videoId}?rel=0`} title={v.title || 'Video'}
              style={{ position:'absolute', inset:0, width:'100%', height:'100%', border:0 }}
              allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowFullScreen referrerPolicy="strict-origin-when-cross-origin"/>
          </div>
          <a href={`https://youtu.be/${v.videoId}`} target="_blank" rel="noreferrer" style={{ display:'inline-block', marginTop:'6px', fontSize:'12px', color:'var(--blue)' }}>Open on YouTube</a>
        </div>
      ))}

      {a.files.length > 0 && (
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', overflow:'hidden' }}>
          <div style={{ padding:'10px 16px', fontSize:'11px', fontWeight:'600', textTransform:'uppercase', letterSpacing:'.5px', color:'var(--muted)', borderBottom:'1px solid var(--border)' }}>Files</div>
          {a.files.map(f => (
            <a key={f.fileId} href={`/api/announcements/view/${encodeURIComponent(token)}/files/${f.fileId}`} download
              style={{ display:'flex', alignItems:'center', gap:'12px', padding:'14px 16px', textDecoration:'none', color:'var(--text)', borderTop:'1px solid var(--border)' }}>
              <i className="ti ti-file-download" style={{ fontSize:'22px', color:'var(--blue)', flexShrink:0 }} aria-hidden="true"/>
              <span style={{ flex:1, minWidth:0, fontSize:'14px', wordBreak:'break-word' }}>{f.name}<span style={{ display:'block', fontSize:'11px', color:'var(--muted)' }}>{f.ext.toUpperCase()} · {fmtSize(f.size)}</span></span>
              <span style={{ fontSize:'12px', color:'var(--blue)', fontWeight:'500' }}>Download</span>
            </a>
          ))}
        </div>
      )}
    </>
  );
}
